<template>
    <v-card class="grey lighten-3">
        <v-container fluid grid-list-xs>
            <v-layout row>
                <v-flex md12>
                    <div class="text-xs-left">
                        <span
                            class="cyan--text text--darken-4 subtitle-1 font-weight-bold"
                        >Historial de Consultas</span>
                    </div>
                </v-flex>
            </v-layout>

            <v-layout row>
                <v-flex xs12>
                    <v-card flat class="grey lighten-3">
                        <v-container pa-1 px-3 mx-0 fluid class="my-list-header">
                            <v-layout row>
                                <v-flex xs2 class="text-left">Fecha</v-flex>
                                <v-flex xs5 class="text-left">Análisis</v-flex>
                                <v-flex xs5 class="text-left">Plan</v-flex>
                            </v-layout>
                        </v-container>

                        <v-list
                            subheader
                            dense
                            style="height: 63px; max-height: 100%"
                            class="overflow-y-auto"
                            :disabled="bEdit"
                        >
                            <v-list-item-group
                                v-model="selectedSale"
                                color="indigo lighten-2"
                                mandatory
                            >
                                <v-list-item
                                    class="my-list-item"
                                    v-for="(sale, i) in salesHistory"
                                    :key="i"
                                    @click="onSale(sale.id)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-container pa-0 fluid>
                                                <v-layout row wrap>
                                                    <v-flex xs2 class="text-left">{{ sale.date }}</v-flex>
                                                    <v-flex
                                                        xs8
                                                        class="text-left"
                                                    >{{ sale.products }}</v-flex>
                                                    <v-flex xs2 class="text-left">{{ sale.total }}</v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ConsultHistory',
    data() {
        return {};
    },
    props: {
        patient: Object
    },
    components: {},
    created() {},
    methods: {},
    computed: {
        ...mapGetters(['waitCursor'])
    }
};
</script>

<style scoped>
.gmp-green {
    color: #0097a7;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}

.my-list-header {
    font-size: 14px;
    font-weight: regular;
    background-color: #e0e0e0;
}

.my-list-item {
    min-height: 30px !important;
}
</style>